import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 2,
  class: "hover-explanation"
}
const _hoisted_3 = { class: "hover-explanation-text" }

import { ref, toRefs } from 'vue'
import CheckboxGeneralDropdown from '@/components/general/selectors/DropdownDashboard/Checkbox/CheckboxGeneralDropdown.vue'

interface Props {
  id: string | null
  checked: boolean
  value: string
  circleColor?: string
  iconSource?: string
  isHeading?: boolean
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownCheckboxRowMapMenu',
  props: {
    id: {},
    checked: { type: Boolean },
    value: {},
    circleColor: {},
    iconSource: {},
    isHeading: { type: Boolean }
  },
  emits: ["toggleOption"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emits = __emit
const { id, checked, value, circleColor, iconSource, isHeading } = toRefs(props)
const showHoverExplanationText = ref(false)
const onToggle = (id: string) => {
  emits('toggleOption', id)
}
const onHover = (event: MouseEvent | TouchEvent) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const targetEl = event.target as HTMLElement
  //showHoverExplanationText.value = targetEl.offsetWidth < targetEl.scrollWidth
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["dropdown-row", { headingRow: _unref(isHeading) }]),
    onMousemove: onHover
  }, [
    _createVNode(CheckboxGeneralDropdown, {
      id: _unref(id),
      checked: _unref(checked),
      onToggle: onToggle
    }, null, 8, ["id", "checked"]),
    _createElementVNode("span", {
      class: _normalizeClass([{ heading: _unref(isHeading) }, "text"])
    }, _toDisplayString(_unref(value)), 3),
    (_unref(circleColor))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "circle",
          style: _normalizeStyle({ backgroundColor: _unref(circleColor) })
        }, null, 4))
      : _createCommentVNode("", true),
    (_unref(iconSource))
      ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "icon-container",
          src: _unref(iconSource)
        }, null, 8, _hoisted_1))
      : _createCommentVNode("", true),
    (showHoverExplanationText.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(value)), 1)
        ]))
      : _createCommentVNode("", true)
  ], 34))
}
}

})